<script>
/* eslint-disable */
import { mapGetters } from "vuex";

import bracketBody from "../../static/assets/images/bracket-body.png";
import bracketTop from "../../static/assets/images/bracket-top.png";
import bracketCenter from "../../static/assets/images/bracket-center.png";
import bracketDown from "../../static/assets/images/bracket-down.png";

export default {
  props: ["circuit"],
  name: "PrintScript",
  data() {
    return {
      loading: true,
      bracketBody,
      bracketTop,
      bracketCenter,
      bracketDown,
    };
  },
  async mounted() {
    this.loading = true;
    this.$store.commit("scripts/setActiveWorkout", this.$route.params.id);
    await this.$store.dispatch("scripts/getCircuits", this.$route.params.id);
    await this.$store.dispatch(
      `scripts/getAutoCueWithRests`,
      this.$route.params.id
    );
    await this.$store.dispatch(
      `${this.currentType}/getActivity`,
      this.$route.params.id
    );
    this.loading = false;
  },
  computed: {
    ...mapGetters({
      cueWithRestItems: "scripts/cueWithRestItems",
      circuits: "scripts/circuits",
      cueWithRestItemsWithCircuit: "scripts/cueWithRestItemsWithCircuit",
    }),

    currentActivity() {
      return this.$store.getters[`${this.currentType}/currentActivity`];
    },
    currentType() {
      const url = this.$route.path;
      if (url.includes("workout")) {
        return "workouts";
      }
      if (url.includes("warmup")) {
        return "warmups";
      }
      if (url.includes("stretch-flow")) {
        return "stretchflows";
      }
      return "commons";
    },
    working_title: {
      get() {
        //return 'EVOLUTION ASS & ABS';
        return this.currentActivity ? this.currentActivity.working_title : "";
      },
    },
    equipments: {
      get() {
        //return 'EQUIPMENT A,  EQUIPMENT B, EQUIPMENT C';
        let equipmentArray = [];
        if (this.currentActivity.selected_equipments) {
          this.currentActivity.selected_equipments.forEach((eqpt) => {
            equipmentArray.push(eqpt["equipment_name"]);
          });
        }
        return equipmentArray.join(", ");
      },
    },
    notes: {
      get() {
        //return 'FREE TEXT GIVE LOTS OF ENERGY, REMEMBER TO KEEP YOUR HIPS LOW THROUGH OUT.';
        return this.currentActivity ? this.currentActivity.notes : "";
      },
    },
    total_sets: {
      get() {
        return this.circuits ? this.circuits.length : "0";
      },
    },
    total_time: {
      get() {
        let time = 0;
        if (this.circuits) {
          this.circuits.forEach((item) => {
            if (item.type == "timer") {
              time = time + item.work;
              time = time + item.rest;
            }
          });
        }
        let d = Number(time);
        var h = Math.floor(d / 3600);
        var m = Math.floor((d % 3600) / 60);
        var s = Math.floor((d % 3600) % 60);
        var hDisplay = h > 0 ? h + (h == 1 ? " HR " : " HRS ") : "";
        var mDisplay = m > 0 ? m + (m == 1 ? " MIN " : " MINS ") : "";
        var sDisplay = s > 0 ? s + (s == 1 ? " S " : " S ") : "";
        return { h: hDisplay, m: mDisplay, s: sDisplay };
      },
    },
    circuits_items: {
      get() {
        let Items = [];
        this.circuits.forEach((circuit, i) => {
          Items[i] = { items: [], type: "", work: "", rest: "" };
          if (circuit.items) {
            Items[i]["type"] = circuit.type;
            Items[i]["work"] = circuit.work;
            Items[i]["rest"] = circuit.rest;
            circuit.items.forEach((items) => {
              let data = {};
              if (items.type == "round") {
                let cItems = [];
                // Get Child Items
                if (items.items) {
                  items.items.forEach((cItem) => {
                    cItems.push({
                      type: cItem.type,
                      name: cItem.type == 'instruction'? cItem.instruction :cItem.name,
                      reps: cItem.reps,
                    });
                  });
                }
                // Set Data
                data = {
                  type: items.type,
                  items: cItems,
                  reps: items.reps,
                };
              }
              if (items.type == "move") {
                // Set Data
                data = {
                  type: items.type,
                  name: items.name,
                  reps: items.reps,
                };
              }
              if (items.type == "instruction") {
                // Set Data
                data = {
                  type: items.type,
                  name: items.instruction,
                  reps: items.reps,
                };
              }
              Items[i]["items"].push(data);
            });
          }
        });
        return Items;
      },
    },
  },
};
</script>
<style lang="scss">
// @font-face {
//   font-family: "Times-Bold";
//   font-style: normal;
//   font-weight: 700;
//   src: url("../assets/fonts/timesbd.otf") format("opentype");
// }
@page {
  size: 21cm 29.7cm;
  margin: 2cm;
}
.xali-admin-script-preview-a4 {
  --alizarin-crimson: #db2828;
  --black: #000000de;
  --tango: #f2711c;
  --white: #ffffff;

  --font-size-l: 80px;
  --font-size-m: 70px;
  --font-size-s: 60px;
  --font-size-xl: 90px;
  --font-size-xxl: 150px;

  --font-family-times-bold: Helvetica;
  -webkit-print-color-adjust: exact;

  height: inherit;
  transform: scale(0.4);
  transform-origin: 0 0;
  -webkit-print-color-adjust: exact;
}

.times-bold-black-70px {
  color: var(--black);
  font-family: var(--font-family-times-bold);
  font-size: var(--font-size-m);
  font-style: normal;
  font-weight: 700;
}

.times-bold-alizarin-crimson-80px {
  color: var(--alizarin-crimson);
  font-family: var(--font-family-times-bold);
  font-size: var(--font-size-l);
  font-style: normal;
  font-weight: 700;
}

.times-bold-tango-70px {
  color: var(--tango);
  font-family: var(--font-family-times-bold);
  font-size: var(--font-size-m);
  font-style: normal;
  font-weight: 700;
}

.times-bold-black-150px {
  color: var(--black);
  font-family: var(--font-family-times-bold);
  font-size: var(--font-size-xxl);
  font-style: normal;
  font-weight: 700;
}

/* screen - xali-admin-script-preview-a4 */
.xali-admin-script-preview-a4 {
  align-items: center;
  background-color: var(--white);
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 2480px;
}

.xali-admin-script-preview-a4 .overlap-group1 {
  align-items: center;
  background: #469a2e;
  background-position: 50% 50%;
  background-size: cover;
  display: flex;
  min-width: 2480px;
  padding: 68px 138px;
  
  
  -webkit-box-pack: justify!important;
    -ms-flex-pack: justify!important;
    justify-content: space-between!important;
}

.xali-admin-script-preview-a4 .group-1215 {
  background-color: var(--white);
  height: 101px;
  margin-top: 1px;
  min-width: 270px;
  padding: 15px 22px;
}

.xali-admin-script-preview-a4 .address {
  color: #469a2e;
  font-family: var(--font-family-times-bold);
  font-size: var(--font-size-s);
  font-weight: 700;
  letter-spacing: 0;
  line-height: 60px;
  min-height: 62px;
  min-width: 224px;
  white-space: nowrap;
}

.xali-admin-script-preview-a4 .evolution-ass-abs {
  color: var(--white);
  font-family: var(--font-family-times-bold);
  font-size: var(--font-size-xl);
  font-weight: 700;
  letter-spacing: 0;
  line-height: 90px;
  min-height: 93px;
  min-width: 1024px;
  text-align: center;
    padding: 0 70px;
}

.xali-admin-script-preview-a4 .group-1216 {
  background-color: var(--white);
  margin-top: 1px;
  min-width: 370px;
}

.xali-admin-script-preview-a4 .address-1 {
  color: #469a2e;
  font-family: var(--font-family-times-bold);
  font-size: var(--font-size-s);
  font-weight: 700;
  letter-spacing: 0;
  line-height: 60px;
  min-height: 62px;
  min-width: 324px;
  text-align: right;
  white-space: nowrap;
  padding: 15px 22px;
  height: 101px;
}

.xali-admin-script-preview-a4 .text-16 {
  color: var(--alizarin-crimson);
  font-family: var(--font-family-times-bold);
  font-size: var(--font-size-s);
  font-weight: 700;
  letter-spacing: 0;
  line-height: 60px;
  margin-left: 90px;
  margin-right: 90px;
  margin-top: 94px;
  min-height: 62px;
  min-width: 1352px;
  text-align: center; 
  text-transform: uppercase;
}
.xali-admin-script-preview-a4 .text-17 {
  color: var(--tango);
  font-family: var(--font-family-times-bold);
  font-size: var(--font-size-s);
  font-weight: 700;
  letter-spacing: 0;
  line-height: 90px;
  margin-left: 2px;
  margin-top: 45px;
  min-height: 152px;
  text-align: center;
  width: 2206px;
  text-transform: uppercase;
}

.items-container {
  border-bottom: solid 3px #000;
  width: 100%;
  margin-top: 75px;
}
.xali-admin-script-preview-a4 .item {
  border-top: solid 3px #000;
  position: relative;
  color: var(--black);
  font-family: var(--font-family-times-bold);
  font-size: var(--font-size-m);
  font-style: normal;
  font-weight: 700;
  display: flex;
}
.item .times {
  color: var(--alizarin-crimson);
  font-family: var(--font-family-times-bold);
  font-size: var(--font-size-l);
  font-style: normal;
  font-weight: 700;
  position: relative;
  display: flex;
}
.item .times span {
  left: 85%;
  letter-spacing: 0;
  line-height: 80px;
  text-align: center;
  top: 0;
  white-space: nowrap;
  margin-left: auto;
  margin-right: 5%;
}
.item .count {
  width: 160px;
  text-align: center;
  border-right: solid 3px #000;
  padding-top: 143px;
}
.item .content {
  color: var(--black);
  font-family: var(--font-family-times-bold);
  font-size: var(--font-size-m);
  font-style: normal;
  font-weight: 700;
  width: 100%;
  margin-top: 37px;
}
.item .all-moves > div {
  padding: 21px 60px;
}
.item .all-moves > div > div {
  padding: 21px 0px;
}
.item .instruction {
  color: var(--tango);
}
.item .round {
  position: relative;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}
.item .round .bracket {
  background-image: var(--bracketBody);
  position: absolute;
  top: 3%;
  display: block;
  height: 94%;
  width: 68px;
  background-size: contain;
  left: 80%;
}
.item .round .bracket .center {
  background-image: var(--bracketCenter);
  content: "";
  width: 68px;
  background-size: contain;
  position: absolute;
  top: calc(50% - 35px);
  height: 70px;
}
.item .round .bracket::before {
  background-color: #ffffff;
  background-image: var(--bracketTop);
  content: "";
  width: 100%;
  height: 48px;
  position: absolute;
  background-size: contain;
  top: -1px;
  left: 0px;
}
.item .round .bracket::after {
  background-color: #ffffff;
  background-image: var(--bracketDown);
  content: "";
  width: 100%;
  height: 48px;
  position: absolute;
  background-size: contain;
  bottom: -1px;
  left: 0px;
}
.item .round .round_num {
  color: var(--black);
  font-family: var(--font-family-times-bold);
  font-size: var(--font-size-xxl);
  font-style: normal;
  font-weight: 700;
  left: 85%;
  letter-spacing: 0;
  line-height: 149px;
  position: absolute;
  top: 35%;
  white-space: nowrap;
}
.item .reps {
    margin-left: 50px;
    min-width: 290px;
    text-align: right;
}
</style>

<template>
  <div v-if="loading"><h3>Loading scripts please wait...</h3></div>
  <div
    class="xali-admin-script-preview-a4 screen"
    v-else
    :style="{
      '--bracketBody': 'url(' + bracketBody + ')',
      '--bracketTop': 'url(' + bracketTop + ')',
      '--bracketCenter': 'url(' + bracketCenter + ')',
      '--bracketDown': 'url(' + bracketDown + ')',
    }"
  >
    <div class="overlap-group1">
      <div class="group-1215">
        <div class="address">{{ total_sets }} SETS</div>
      </div>
      <div class="evolution-ass-abs">{{ working_title }}</div>
      <div class="group-1216">
        <div class="address-1" v-if="total_time.h && currentActivity.timer_on_screen != 'no' || total_time.m && currentActivity.timer_on_screen != 'no' || total_time.s && currentActivity.timer_on_screen != 'no'">
          {{ total_time.h }}{{ total_time.m }}{{ total_time.s }}
        </div>
      </div>
    </div>
    <div class="text-16">{{ equipments }}</div>
    <div class="text-17">{{ notes }}</div>
    <div class="items-container">
      <div
        class="item"
        v-for="(circuit, index) in circuits_items"
        :key="circuit.id"
      >
        <div class="count">{{ index + 1 }}</div>
        <div class="content">
          <div class="times">
            <span v-if="circuit.type === 'timer'"
              >{{ circuit.work }} / {{ circuit.rest }}</span
            >
            <span v-else>REPS</span>
          </div>
          <div class="all-moves">
            <template v-for="item in circuit.items">
              <div class="round" v-if="item.type === 'round'" :key="item.id">
                <template v-for="cItem in item.items">
                  <div :key="cItem.id" class="d-flex align-items-center" style="width: 80%;">
                    {{ cItem.name }}
                    <span class="reps" v-if="cItem.reps > 1"
                      >X {{ cItem.reps }}</span
                    >
                  </div>
                </template>
                <span class="bracket"><span class="center"></span></span>
                <div class="round_num">X {{ item.reps }}</div>
              </div>
              <div v-if="item.type === 'move'" :key="item.id" class="move">
                {{ item.name }}
                <span class="reps" v-if="item.reps > 1">X {{ item.reps }}</span>
              </div>
              <div
                v-if="item.type === 'instruction'"
                :key="item.id"
                class="instruction"
              >
                {{ item.name }}
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
